/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PostCommentFormContainer_viewer = {
    readonly id: string;
    readonly scheduledDeletionDate: string | null;
    readonly " $refType": "PostCommentFormContainer_viewer";
};
export type PostCommentFormContainer_viewer$data = PostCommentFormContainer_viewer;
export type PostCommentFormContainer_viewer$key = {
    readonly " $data"?: PostCommentFormContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PostCommentFormContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PostCommentFormContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledDeletionDate",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'a35cfc3b763ab0027397bfd8b7602a92';
export default node;
